<template>
	<v-dialog v-model="showDialog" persistent scrollable width="600px">
		<v-card>
			<v-card-title> Manage views </v-card-title>

			<v-card-text>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th>View name</th>
								<th class="text-right">Set as Default</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="viewsList.length === 0">
								<td>No views available</td>
							</tr>
							<tr v-for="view in viewsList" :key="view.Id">
								<td>{{ view.Name }}</td>
								<td class="text-right">
									<v-switch
										v-if="view.UserId != null"
										v-model="view.IsDefault"
										class="ma-0 pa-0 float-right"
										color="primary"
										@change="onIsDefaultChanged(view)"
									/>
								</td>
								<td class="d-flex align-center justify-end">
									<v-btn
										v-if="view.UserId != null"
										small
										icon
										elevation="1"
										class="action-btn"
										color="red"
										@click="deleteView(view)"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-btn text outlined @click="close"> Close </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
export default {
	name: 'ManageViewsDialog',
	props: {
		showDialog: Boolean,
		deleteViewAction: String,
		setDefaultViewAction: String,
		viewsList: Array,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onIsDefaultChanged(view) {
			this.$store.dispatch(this.setDefaultViewAction, view);
		},
		deleteView(view) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this view?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(this.deleteViewAction, view);
			});
		},
	},
};
</script>

<style lang="scss">
.v-input--switch {
	.v-input__slot {
		margin-bottom: 0;
	}
	.v-messages {
		display: none;
	}
}
</style>
